import type { ReactNode } from "react";
import Message from "@/components/common/Message";
import { describeError } from "@/lib/api/client";

/** The results column: the failure, the wait, the empty line, or the cards; then the pager. */
export default function JobsResults({
    error,
    pending,
    empty,
    pager,
    children,
}: {
    error: Error | null;
    pending: boolean;
    /** The line in place of the cards, or null when there are cards. */
    empty: string | null;
    pager: ReactNode;
    children: ReactNode;
}) {
    return (
        <section aria-label="Results" className="flex min-w-0 flex-[999_1_480px] flex-col gap-2.5">
            {error ? (
                <Message>{describeError(error)}</Message>
            ) : pending ? (
                <Waiting />
            ) : empty !== null ? (
                <div className="rounded-card border border-line bg-card px-5 py-[18px] text-[13px] text-fg-muted shadow-card">
                    {empty}
                </div>
            ) : (
                children
            )}
            {pager}
        </section>
    );
}

/**
 * The wait: blank cards the height of a result (JobCard), enough to fill
 * the screen, so what sits under the list is already below the fold and
 * does not move when the cards land.
 */
function Waiting() {
    return (
        <div role="status" className="flex flex-col gap-2.5">
            <span className="sr-only">Reading the catalogue…</span>
            {Array.from({ length: 6 }, (_, index) => (
                <div
                    key={index}
                    aria-hidden="true"
                    className="h-[166px] rounded-card border border-line bg-card shadow-card"
                />
            ))}
        </div>
    );
}
